import ComponentVariantEditor from './ComponentVariantEditor';
export default ComponentVariantEditor;
